import { render, staticRenderFns } from "./RecollectMainView.vue?vue&type=template&id=3f62d9b9&scoped=true"
import script from "./RecollectMainView.vue?vue&type=script&lang=js"
export * from "./RecollectMainView.vue?vue&type=script&lang=js"
import style0 from "./RecollectMainView.vue?vue&type=style&index=0&id=3f62d9b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f62d9b9",
  null
  
)

export default component.exports